import React from "react";

const LOGO_URL = `${process.env.PUBLIC_URL || ""}/spc-logo.png`;

// SPC Performance Nutrition brand badge (diamond shield only).
export default function Logo({ className = "h-10 w-10" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Performance Nutrition"
      data-testid="brand-logo"
      className={`${className} object-contain shrink-0 cursor-pointer select-none`}
      draggable={false}
    />
  );
}
